import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=1adf8cb8&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=1adf8cb8&lang=sass&scoped=true&"
import style1 from "./menu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf8cb8",
  null
  
)

export default component.exports
import {QDrawer,QList,QItem,QItemSection,QIcon,QItemLabel,QExpansionItem,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDrawer,QList,QItem,QItemSection,QIcon,QItemLabel,QExpansionItem,QCard,QCardSection})
